import React, { useEffect, useState } from "react";
import { Label } from "reactstrap";
import { MultiSelect } from "react-multi-select-component";
import { EMPLOYEE_GET_TEAM, GET_EMPLOYEE, GET_TEAM } from "../../helpers/url_helper";
import { APIClient } from "../../helpers/api_helper";
import { toast } from "react-toastify";
const api = new APIClient();

const TeamSelect = ({
  teamIndu,
  setTeamIndu,
  labelContent,
  setSelectedEmployeeOptions,
}) => {
  const storedValue = JSON.parse(localStorage.getItem("logintype"));
  const permissionType = JSON.parse(localStorage.getItem("permission"));
  const GetTeampermission = permissionType?.includes("GET_TEAMS");
  const [dataFetched, setDataFetched] = useState(false);
  const [options, setOptions] = useState([]);
  let employeeTotalCount;

  const fetchTeamData = async () => {
    try {
      let response;
      if (storedValue === "employee" && permissionType.length > 0) {
        response = await api.get(`${EMPLOYEE_GET_TEAM}`);
      } else if (storedValue === "organization") {
        response = await api.get(`${GET_TEAM}`);
      }

      //Employee count determine for organization
      if (storedValue === "organization") {
        const employeeData = await api.get(`${GET_EMPLOYEE}`);
        employeeTotalCount = employeeData?.data?.length;
      }

      // Get team options from API response
      const teamOptions = response?.data?.teams?.map((item) => ({
        id: item?._id,
        label: item?.teamName,
        value: item?.teamName,
      })) || [];

      // Only add unAssign team option if storedValue is organization
      let fetchedOptions = [...teamOptions];
      if (storedValue === "organization" && employeeTotalCount) {
        fetchedOptions.push({
          id: "678a0497b3160343ed68b110",
          label: "Unassigned",
          value: "unAssignteam"
        });
      }
      if (fetchedOptions.length > 0) {
        // Check if we're on the leads route
        const currentPath = window.location.pathname;
        
        // Always set teamIndu for all routes
    
        setOptions(fetchedOptions);
        setDataFetched(true);

        // Only set options if we're NOT on the /leads route
        if (currentPath !== "/leads") {
          setTeamIndu(fetchedOptions);
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        console.error("Permission denied. Please check your permissions.");
        toast.error("Permission denied. Please check your permissions.", {
          autoClose: 1000,
        });
      } else {
        console.error("An error occurred:", error);
      }
    }
  };



  useEffect(() => {
    if (!dataFetched) {
      fetchTeamData();
    }
  }, [dataFetched]);



  const handleSelectChange = (selectedOptions) => {
    setTeamIndu(selectedOptions);
    setSelectedEmployeeOptions([]);
  };

  return (
    <>
      <Label>{labelContent}</Label>
      <MultiSelect
        disabled={
          !GetTeampermission && storedValue === "employee"
            ? true
            : storedValue === "organization"
              ? false
              : false
        }
        options={options}
        value={teamIndu}
        onChange={handleSelectChange}
        // labelledBy={"Select"}
        // isCreatable={true}
        // overrideStrings={{ selectSomeItems: "Select Teams" }}
        // hasSelectAll={true}
        className="classgroup"
      // onMenuToggle={(isOpen) => {
      //   if (isOpen && !dataFetched) {
      //     setSelectedEmployeeOptions([]);
      //     fetchTeamData();
      //   }
      // }}
      />
    </>
  );
};

export default TeamSelect;
